<template>
  <button
    :type="type"
    class="ds-button"
    :class="[variant, size]"
    :disabled="disabled"
    @click="$emit('click', $event)"
  >
    <slot />
  </button>
</template>

<script>
export const DS_BUTTON_VARIANTS = ['primary', 'secondary', 'ghost', 'danger']

export default {
  name: 'DsButton',
  props: {
    // 'submit' lets a form submit through the design system instead of a hand-rolled button.
    type: {
      type: String,
      default: 'button',
      validator: value => ['button', 'submit'].includes(value),
    },
    variant: {
      type: String,
      default: 'primary',
      validator: value => DS_BUTTON_VARIANTS.includes(value),
    },
    size: {
      type: String,
      default: 'md',
      validator: value => ['md', 'sm'].includes(value),
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style scoped lang="scss">
@import '~@/design-system/mixins';

.ds-button {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  padding: 9px 18px;
  border-radius: 8px;
  font-size: 12.5px;
  font-weight: 600;
  font-family: inherit;
  cursor: pointer;

  // The UA paints its own blue ring on :focus; the orange one is kept for :focus-visible,
  // so keyboard users still get an indicator.
  &:focus {
    outline: none;
  }

  &:focus-visible { @include ds-focus-ring; }

  &:disabled {
    opacity: 0.65;
    cursor: default;
  }

  &.primary {
    border: none;
    background: $c-orange;
    color: $c-wine;
  }

  &.secondary {
    border: 1px solid $c-border;
    background: $c-white;
    color: $c-text-sec;
  }

  &.ghost {
    border: 1px solid transparent;
    background: transparent;
    color: $c-text-sec;

    &:hover:not(:disabled) {
      background: $c-bg;
      color: $c-text;
    }
  }

  &.danger {
    border: 1px solid rgba($c-danger, 0.22);
    background: $c-danger-light;
    color: $c-danger-text;

    &:hover:not(:disabled) { background: rgba($c-danger, 0.12); }
  }

  &.sm {
    padding: 6px 12px;
    font-size: 12px;
    border-radius: 7px;
  }
}
</style>
